<template>
  <div>
    <div
      style="color: #0C2F53; font-weight: 700; font-size: 24px; margin-right: 3%; margin-left: 2.5%; margin-top: -1%;"
    >
      {{ 'Livechat' }}
    </div>
    <div
      style="box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); width: 1056px; margin-right: 3%; margin-left: 2.5%; margin-bottom: 1%;"
    >
      <livechat-search
        :input="input"
        :tagOptions="tagOptions"
        @addTag="addTag"
        @clearSearch="clearSearch"
        @onSearch="onSearch"
        v-model="showSearch"
      ></livechat-search>
      <div id="livechat">
        <v-layout fill-height>
          <v-flex shrink fill-height>
            <!-- <template v-if="$store.state.livechat.pageid">
            <livechat-pagelist
              :value="$store.state.livechat.pageid"
              @changePage="changePage"
            ></livechat-pagelist>
          </template> -->
          </v-flex>
          <v-flex style="position: relative">
            <v-layout :style="{ width: selectedUser ? '100%' : '330px' }">
              <v-flex style="width: 317px;">
                <!-- max-width: 20%; min-width: 265px -->
                <!-- border-right: 1px solid #eee; -->
                <div id="chattype">
                  <template v-if="searchlist.length == 0 || showSearch">
                    <livechat-tab
                      :newchatnotify="newchatnotify"
                      @onsearch="showSearch = true"
                      :AdminID="AdminID"
                      style="border-right: 1px solid #eee;"
                    ></livechat-tab>
                  </template>
                  <template v-else-if="searchlist.length != 0 && !showSearch">
                    <!--  @onsearch="showSearch = true" -->
                    <livechat-search-box
                      style="border-right: 1px solid #eee;"
                      @deleteTagNSearch="deleteTagNSearch"
                      @clearSearch="clearSearch"
                      :showSearch="showSearch"
                    ></livechat-search-box>
                    <v-divider></v-divider>
                  </template>
                </div>

                <div v-if="$store.state.livechat.app">
                  <users
                    :app="$store.state.livechat.app"
                    :usersearching="usersearching"
                    :filter="filter"
                    :type="'all'"
                  ></users>
                  
                  <!-- v-if="$store.state.livechat.type == 'admin'" -->
                  <!-- 
                  <users
                  :app="$store.state.livechat.app"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'bot'"
                  
                ></users> -->
                  <!-- v-if="$store.state.livechat.type == 'bot'" -->
                </div>
              </v-flex>
              <v-flex>
                <v-layout>
                  <v-flex
                    style="border-right: 1px solid #eee; position: relative; width: 415px;"
                    fill-height
                    v-if="selectedUser"
                    :key="`chat_${selectedUser.userid}_${selectedUser.type}`"
                  >
                    <chatbox
                      @endSession="onEndSession"
                      @openSession="onOpenSession"
                      :key="selectedUser.userid"
                    ></chatbox>
                  </v-flex>
                  <v-flex style="position: relative; width: 288px;" fill-height v-if="selectedUser">
                    <livechat-chattool :selectedUser="selectedUser"></livechat-chattool>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import Livechat from './Livechat.js'
export default {
  mixins: [Livechat]
}
</script>
<style>
.newnotifycount {
  height: 16px;
  line-height: 16px;
  border-radius: 15px;
  position: absolute;
  right: 3px;
  top: 5px;
  background-color: #ff6565;
  width: 15px;
  font-size: 10px;
  color: white;
}
.custom-scroll::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.custom-scroll::-webkit-scrollbar-track {
  background-color: #ffffff;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #0c2f53;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/Livechat.vue